// extracted by mini-css-extract-plugin
export default {"message":"SingleConfirmationModal__message___lnkbW"};